import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Browser } from '@syncfusion/ej2-base';
import { useTranslation } from 'react-i18next';

import useApi from 'hooks/useApi';
import { addBreadcrumb, removeBreadcrumb } from 'redux/actions/layoutActions';
import { getActiveDetail } from 'redux/actions/notificationReviewActions';
import { getActiveDocument } from 'redux/actions/documentActions';
import { getDownloadUrl, setCustomerAdmins, setIsAutoLogin } from 'redux/actions/authActions';
import { setDeleteClientFromHome } from 'redux/actions/clientActions';
import { closeAlert } from 'redux/actions/alertActions';

import AlertModal from 'shared/components/AlertModal';

import ClientSectionCard from './components/ClientSectionCard';
import DocumentSectionCard from './components/DocumentSectionCard';
import NotificationSectionCard from './components/NotificationSectionCard';
import CalendarSectionCard from './components/CalendarSectionCard';
import MailSectionCard from './components/MailSectionCard';

import { DashboardWrapper } from './styles';

const Home = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { customAreaApi } = useApi();
  const { isCustomer, urlDownload, cusNavId, isAutoLogin } = useSelector((state) => state.auth);
  const { breadcrumbs } = useSelector((state) => state.layout);
  const { activeDetail } = useSelector((state) => state.notificationReview);
  const { activeDocument } = useSelector((state) => state.document);
  const { openAlert, alertType, alertMessage } = useSelector((state) => state.alertState);
  const [clients, setClients] = useState([]);

  const onCloseAlert = () => dispatch(closeAlert());

  const [, getCustomerAdmins] = customAreaApi(
    {
      url: `${window.API_V1}/cli/contacts/${cusNavId}/admins?adminActive=false`,
      method: 'GET',
    },
    { manual: true }
  );

  const [, getClientsData] = customAreaApi(
    {
      url: `${window.API_V1}/cli/clients/${cusNavId}/search`,
      method: 'POST',
    },
    { manual: true }
  );

  const clientsData = async () => {
    const {
      data: { data },
    } = await getClientsData({
      data: {
        filters: [
          {
            model: 'Client',
            field: 'ClientId',
          },
        ],
        reduce: {
          limit: 0,
          skip: 0,
        },
      },
    });
    setClients(data);
  };

  useEffect(() => {
    if (isCustomer) {
      clientsData();
    }
  }, []);

  const fetchCustomerAdmins = async () => {
    try {
      const {
        data: { data },
      } = await getCustomerAdmins();
      dispatch(setCustomerAdmins(data));
    } catch (ex) {
      console.error('ex');
    }
  };

  useEffect(() => {
    if (isAutoLogin) {
      dispatch(setIsAutoLogin(false));
    }
  }, [isAutoLogin]);

  useEffect(() => {
    fetchCustomerAdmins();
    dispatch(setDeleteClientFromHome(false));
  }, []);

  useEffect(() => {
    if (breadcrumbs.length > 1) {
      breadcrumbs.forEach(() => {
        dispatch(removeBreadcrumb());
      });
    }
    dispatch(
      addBreadcrumb({
        active: false,
        label: 'general_home',
        link: '/home',
        isModify: false,
      })
    );
  }, []);

  useEffect(() => {
    if (activeDetail) {
      dispatch(getActiveDetail(null));
      setTimeout(() => {
        history.push(activeDetail);
      }, 500);
    }
    if (activeDocument) {
      dispatch(getActiveDocument(null));
      setTimeout(() => {
        history.push(activeDocument);
      }, 500);
    }
    if (urlDownload) {
      dispatch(getDownloadUrl(null));
      setTimeout(() => {
        history.push(urlDownload);
      }, 500);
    }
  }, []);

  if (isCustomer) {
    return (
      <DashboardWrapper>
        <div className="d-flex-dashboard mb-4">
          <ClientSectionCard />
          <DocumentSectionCard className="mr-5" clients={clients} />
        </div>
        <div className="d-flex-dashboard">
          <NotificationSectionCard className="mb-4" clients={clients} />
          <CalendarSectionCard className="mb-4 mr-5" />
        </div>
        {!Browser.isDevice && (
          <div className="d-flex-dashboard">
            <MailSectionCard className="mb-4" />
          </div>
        )}
        <AlertModal
          type={alertType}
          isOpen={openAlert}
          toggle={onCloseAlert}
          message={alertMessage}
          okText={t('general_button_ok')}
          onOk={onCloseAlert}
        />
      </DashboardWrapper>
    );
  }
  return (
    <DashboardWrapper>
      <div className="d-flex-dashboard mb-4">
        <DocumentSectionCard />
        <NotificationSectionCard className="mr-5" />
      </div>
      <AlertModal
        type={alertType}
        isOpen={openAlert}
        toggle={onCloseAlert}
        message={alertMessage}
        okText={t('general_button_ok')}
        onOk={onCloseAlert}
      />
    </DashboardWrapper>
  );
};

export default Home;
